import { gql } from '@apollo/client'

export const GET_ADVERSE_ACTION_CASES = gql`
  query GetAdverseActionCases($pageInfo: PageInfoInput) {
    adverseActionCases(pageInfo: $pageInfo) {
      items {
        adverseActionCaseId
        createdAt
        updatedAt
        status
        disqualifiedReason
        preNoticeScheduledFor
        preNoticeSentAt
        finalNoticeScheduledFor
        finalNoticeSentAt
        applicant {
          applicantId
          firstName
          lastName
          fullName
        }
        company {
          companyId
          companyName
        }
        recruiter {
          employeeId
          firstName
          lastName
        }
        preNoticeEmail {
          emailId
          subject
          date
        }
        finalNoticeEmail {
          emailId
          subject
          date
        }
      }
      totalCount
      pageInfo {
        limit
        offset
      }
    }
  }
`

export const GET_ADVERSE_ACTION_CASE = gql`
  query GetAdverseActionCase($adverseActionCaseId: String!) {
    adverseActionCase(adverseActionCaseId: $adverseActionCaseId) {
      adverseActionCaseId
      createdAt
      updatedAt
      status
      disqualifiedReason
      preNoticeScheduledFor
      preNoticeSentAt
      finalNoticeScheduledFor
      finalNoticeSentAt
      applicant {
        applicantId
        firstName
        lastName
        fullName
      }
      company {
        companyId
        companyName
      }
      recruiter {
        employeeId
        firstName
        lastName
      }
      preNoticeEmail {
        emailId
        subject
        body
        date
      }
      finalNoticeEmail {
        emailId
        subject
        body
        date
      }
      backgroundDocuments {
        documentId
        fileName
        category
        status
        createdAt
      }
      disputeDocuments {
        documentId
        fileName
        category
        status
        createdAt
      }
    }
  }
`

export const CREATE_ADVERSE_ACTION_CASE = gql`
  mutation CreateAdverseActionCase($input: CreateAdverseActionCaseInput!) {
    createAdverseActionCase(input: $input) {
      adverseActionCaseId
      createdAt
      updatedAt
      status
      disqualifiedReason
      preNoticeScheduledFor
      preNoticeSentAt
      finalNoticeScheduledFor
      finalNoticeSentAt
      applicant {
        applicantId
        firstName
        lastName
        fullName
      }
      recruiter {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const UPDATE_ADVERSE_ACTION_CASE = gql`
  mutation UpdateAdverseActionCase(
    $adverseActionCaseId: String!
    $input: UpdateAdverseActionCaseInput!
  ) {
    updateAdverseActionCase(
      adverseActionCaseId: $adverseActionCaseId
      input: $input
    ) {
      adverseActionCaseId
      createdAt
      updatedAt
      status
      disqualifiedReason
      preNoticeScheduledFor
      preNoticeSentAt
      finalNoticeScheduledFor
      finalNoticeSentAt
      applicant {
        applicantId
        firstName
        lastName
        fullName
      }
      recruiter {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const DELETE_ADVERSE_ACTION_CASE = gql`
  mutation DeleteAdverseActionCase($adverseActionCaseId: String!) {
    deleteAdverseActionCase(adverseActionCaseId: $adverseActionCaseId) {
      adverseActionCaseId
      status
      applicant {
        applicantId
        firstName
        lastName
        fullName
      }
    }
  }
`

export const GET_ADVERSE_ACTION_CASES_BY_APPLICANT = gql`
  query GetAdverseActionCasesByApplicant($applicantId: String!) {
    adverseActionCasesByApplicant(applicantId: $applicantId) {
      adverseActionCaseId
      createdAt
      updatedAt
      status
      disqualifiedReason
      preNoticeScheduledFor
      preNoticeSentAt
      finalNoticeScheduledFor
      finalNoticeSentAt
      applicant {
        applicantId
        firstName
        lastName
        fullName
      }
      company {
        companyId
        companyName
      }
      recruiter {
        employeeId
        firstName
        lastName
      }
      preNoticeEmail {
        emailId
        subject
        date
      }
      finalNoticeEmail {
        emailId
        subject
        date
      }
    }
  }
`
